import request from '@/utils/request';

// 1. 查询企业应用列表
export function fetchEnteriseAppList(params) {
  return request({
    url: '/delivery-server/customers/deliveryapps',
    method: 'get',
    params
  });
}
// 1. 查询企业应用详情
export function fetchEnterpriseAppInfo(params) {
  return request({
    url: `/delivery-server/customers/deliveryapps/${params.appID}`,
    method: 'get'
  });
}

// 1. 查询企业应用服务商列表
export function fetchEnteriseAppServiceList() {
  return request({
    url: '/delivery-server/customers/markets',
    method: 'get',
    params: {
      page: 1,
      pageSize: 99
    }
  });
}
// 提交商业咨询
export function fetchEnterpriseBusiness(data) {
  return request({
    method: 'POST',
    url: '/enterprise-server/business/consult',
    data
  });
}
// 获取线索
export function fetchEnterpriseClue(params) {
  return request({
    method: 'GET',
    url: `/enterprise-server/enterprise/${params.eid}/business/list`,
    params: {
      page: params.page,
      pageSize: params.pageSize
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/enteriseApp.js